<script lang="ts">
    import { _ } from "svelte-i18n"
    import { initialLocale } from "../../i18n"
    import { location } from "../../i18n"

    import Index from "../SEO/Index.svelte"
    import PrefilteredSelectionList from "../ecommerce/product/preview/PrefilteredSelectionList.svelte"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { buildProductSearchFilter, getSearchWords, scoreProductSearchMatch } from "../../functionTools/search.js"
    import { trackEvent } from "../../lib/ga"

    let count = $state<number>()
    let lastSearchTracked = $state("")

    let search = $derived(decodeURIComponent($location.search?.substr(1)))

    let filter: object = $state()
    $effect(() => {
        filter = buildProductSearchFilter(search, initialLocale)
    })

    // GA4 search — einmal pro Suchbegriff sobald Trefferzahl bekannt
    $effect(() => {
        const term = (search || "").trim()
        if (count !== undefined && term && term !== lastSearchTracked) {
            lastSearchTracked = term
            trackEvent("search", { search_term: term })
        }
    })

    function sortFn(a: Product, b: Product) {
        const words = getSearchWords(search)
        const aScore = scoreProductSearchMatch(a, words)
        const bScore = scoreProductSearchMatch(b, words)

        // @ts-ignore
        a._text_score = aScore
        // @ts-ignore
        b._text_score = bScore

        return bScore - aScore
    }
</script>

<Index title={$_("search.search-for", { values: { search } })} metaDescription={$_("meta.description")} />
<section class="section-type-1">
    <div class="container-fluid">
        <div class="products_header">
            <h3>
                {@html $_("search.search-for-html", {
                    values: { search },
                })}
                {#if count}<small
                        >({$_("search.count-hits", {
                            values: { count },
                        })})</small
                    >{/if}
            </h3>
        </div>
        {#if !filter}
            <BarLoader />
        {:else}
            <!-- later change of filter state does not trigger update in PrefilteredSelectionList -->
            <PrefilteredSelectionList byFilter={filter} limit={1000} {sortFn} bind:count />
        {/if}
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .section-type-1 {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 0 1.2rem;
    }
    .container-fluid {
        max-width: var(--max-container-width);
        width: 100%;
        padding: 0px;
        margin: 0px;
    }
    .products_header {
        .flex();
        justify-content: space-between;
    }
</style>
